import { useState } from "react";
import { API } from "@/lib/api";
import { logger } from "@/lib/logger";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { FileSpreadsheet, FileText, Download } from "lucide-react";

const STATUSES = ["Recebida","Em Triagem","Documentação Pendente","Em Análise","Aprovada","Indeferida","Homologada"];

export default function RelatoriosPage() {
  const [status, setStatus] = useState("");
  const [bairro, setBairro] = useState("");

  const exportar = (fmt) => {
    const params = new URLSearchParams();
    if (status && status !== "all") params.set("status", status);
    if (bairro) params.set("bairro", bairro);
    // Usa o cookie httpOnly automaticamente via credentials: include.
    fetch(`${API}/exports/${fmt}?${params.toString()}`, { credentials: "include" })
      .then((r) => r.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = `inscricoes.${fmt}`; a.click();
        URL.revokeObjectURL(url);
      })
      .catch((e) => logger.error("Falha na exportação", e));
  };

  return (
    <div className="space-y-6" data-testid="relatorios-page">
      <div>
        <h1 className="text-3xl font-black text-[#083CA6]">Relatórios</h1>
        <p className="text-sm text-slate-600">Exporte os dados das inscrições em Excel, CSV ou PDF.</p>
      </div>

      <Card>
        <CardHeader><CardTitle className="text-base">Filtros</CardTitle><CardDescription>Aplicáveis aos relatórios exportados</CardDescription></CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <Label>Status</Label>
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger data-testid="rel-status"><SelectValue placeholder="Todos" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Todos</SelectItem>
                  {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div><Label>Bairro</Label><Input value={bairro} onChange={(e) => setBairro(e.target.value)} placeholder="Filtrar por bairro" data-testid="rel-bairro" /></div>
          </div>
        </CardContent>
      </Card>

      <div className="grid md:grid-cols-3 gap-4">
        <Card className="border-green-200">
          <CardContent className="p-6 text-center">
            <FileSpreadsheet className="w-10 h-10 mx-auto text-green-600 mb-3" />
            <h3 className="font-bold mb-1">Excel (.xlsx)</h3>
            <p className="text-xs text-slate-500 mb-4">Planilha com todas as inscrições filtradas</p>
            <Button onClick={() => exportar("xlsx")} className="bg-green-600 hover:bg-green-700 w-full" data-testid="export-xlsx"><Download className="w-4 h-4 mr-2" />Exportar Excel</Button>
          </CardContent>
        </Card>
        <Card className="border-blue-200">
          <CardContent className="p-6 text-center">
            <FileText className="w-10 h-10 mx-auto text-blue-600 mb-3" />
            <h3 className="font-bold mb-1">CSV</h3>
            <p className="text-xs text-slate-500 mb-4">Arquivo CSV compatível com qualquer sistema</p>
            <Button onClick={() => exportar("csv")} className="bg-blue-600 hover:bg-blue-700 w-full" data-testid="export-csv"><Download className="w-4 h-4 mr-2" />Exportar CSV</Button>
          </CardContent>
        </Card>
        <Card className="border-red-200">
          <CardContent className="p-6 text-center">
            <FileText className="w-10 h-10 mx-auto text-red-600 mb-3" />
            <h3 className="font-bold mb-1">PDF</h3>
            <p className="text-xs text-slate-500 mb-4">Relatório formatado para impressão</p>
            <Button onClick={() => exportar("pdf")} className="bg-red-600 hover:bg-red-700 w-full" data-testid="export-pdf"><Download className="w-4 h-4 mr-2" />Exportar PDF</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
